<template>
  <div class="container">
    <form class="needs-validation" id="page-form" data-toggle="validator" novalidate>
      <div class="form-group-container">
        <div class="main-list-container">
          <div class="col-12">
            <h1 class="page-title">Reservations</h1>
          </div>
          <div class="col-12 row list-container-row">
            <div class="col-12" v-if="this.selectedEvent !== null && typeof this.selectedEvent.title !== 'undefined'">
              <h3>{{ this.selectedEvent.title }}</h3>
              <!-- <h4 class="error-message">group by users</h4> -->
              <div class="row">
                <div class="col-12 date-time">
                  {{ this.selectedEvent.starts | dateFilterFormatUKEventDisplay }}
                  <br />
                  {{ this.selectedEvent.starts | timeFilter }}
                </div>
              </div>
            </div>
            <div class="col-12 bottom-buttons">
                  <div class="row">
                    <div class="col-6">
                      <div class="button button-admin-home">
                        <router-link class="btn btn-primary href-btn btn-sm" to="/admin/">Admin home</router-link>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <div class="button text-right">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="exportData()">
                          <span>Export</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
            <div class="col-12 pull-left no-gutters list-container-item list-container-item-right">
              <div class="list-container">
                <table class="table" v-if="this.items.length > 0">
                  <thead class="table-head-blue table-head">
                    <tr>
                      <th scope="col">Title</th>
                      <th scope="col" class="hide-on-sm col-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in this.items" :key="index">
                      <td>
                        <div class="col-12 reserved-user">{{ item.user.firstname }}, {{ item.user.lastname }}</div>

                        <!-- {{item.bookedSeats}} - seats reserved ({{item.booking.totalSeats}} -->

                        <div v-if="item.bookings !== null">
                          <div v-for="(reserved, subIndex) in item.bookings" :key="subIndex">
                            <div class="col-12">
                              <p class="booking-reference">
                                Reservation reference: <span>{{ reserved.bookingReference }}</span>
                              </p>
                            </div>
                            <table class="table" v-if="reserved.bookedSeats.length > 0">
                              <tbody>
                                <tr v-for="(reservedSeat, reservedIndex) in reserved.bookedSeats" :key="reservedIndex">
                                  <td class="col-1">
                                    <span class="seat-code">{{ reservedSeat.seat.code }}</span>
                                  </td>
                                  <td scope="col">{{ reservedSeat.firstname }}, {{ reservedSeat.lastname }}</td>
                                  <td scope="col" class="col-2">{{ reservedSeat.contactNo }}</td>
                                  <td scope="col" class="col-1">
                                    <a v-on:click="showDeleteDialog(reservedSeat.bookingId, reservedSeat.id)" class="href-btn">
                                      <i class="fas fa-minus-circle red remove-icon tg-icon" aria-hidden="true"></i>
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div class="buttons d-md-none row">
                          <div class="col-12 date-time"></div>
                          <div class="col-12">
                            <!-- <router-link
                              :to="'/admin/events/edit/' + item.id"
                              class="btn btn-primary href-btn btn-sm button-right-margin"
                            >edit</router-link>-->
                            <!-- <router-link
                              :to="'/admin/bookings/' + item.id"
                              class="btn btn-primary href-btn btn-sm button-right-margin"
                            >bookings</router-link>-->
                            <router-link class="btn btn-danger href-btn btn-sm" :to="'/admin/events/delete/' + item.id">delete</router-link>
                          </div>
                        </div>
                      </td>

                      <td class="small-button hide-on-sm">
                        <div class>
                          <!-- <router-link
                            :to="'/admin/events/edit/' + item.id"
                            class="btn btn-primary href-btn btn-sm button-right-margin"
                          >edit</router-link>-->
                          <!-- <router-link
                            :to="'/admin/bookings/' + item.id"
                            class="btn btn-primary href-btn btn-sm button-right-margin"
                          >bookings</router-link>-->
                          <router-link class="btn btn-danger href-btn btn-sm" :to="'/admin/events/delete/' + item.id">delete</router-link>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-12 no-records" v-if="items.length === 0">
                  <div class="row">
                    <h5>Nothing to display!</h5>
                  </div>
                </div>

                <div class="col-12 bottom-buttons">
                  <div class="row">
                    <div class="col-6">
                      <div class="button button-admin-home">
                        <router-link class="btn btn-primary href-btn btn-sm" to="/admin/">Admin home</router-link>
                      </div>
                    </div>
                    <div class="col-6 text-right">
                      <div class="button text-right">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="exportData()">
                          <span>Export</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <GenericDialog :showCloseButton="true" :showGenericDialog="showGenericDeleteDialog" @close="closeGenericDeleteDialog" :content="genericDialogContent">
            <div class="row">
              <div class="col-12">
                <h3>Are you sure you want to remove this reservation?</h3>
                <!-- <p>{{ this.seatData.code }}</p> -->
              </div>
              <div class="col-12">
                <div class="form-group row">
                  <div class="col-12 col-lg-12r">
                    <div class="row center-align text-cente">
                      <div class="col-3">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="removeSeatBooking()">
                          <span>Remove</span>
                        </a>
                      </div>
                      <div class="col-3">
                        <a class="href-btn btn-sm btn default-btn-color btn-primary" v-on:click="closeGenericDeleteDialog()">
                          <span>Cancel</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </GenericDialog>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { BookingService } from "@/services/ApiService";
import GenericDialog from "@/components/controls/GenericDialog.vue";
import dateFilter from "@/filters/dateFilter";
import dateFilterFormatUKEventDisplay from "@/filters/dateFilterFormatUKEventDisplay";
import timeFilter from "@/filters/timeFilter";
import commonMixin from "@/mixins/commonMixin";
import { toastNotificationComputed, toastNotificationMethods, toastNotificationMutations } from "@/state/helpers";

export default {
  name: "ListBookings",
  filters: { dateFilter, timeFilter, dateFilterFormatUKEventDisplay },
  mixins: [commonMixin],
  components: {
    GenericDialog
  },
  data() {
    return {
      items: [],
      selectedEvent: {},
      showGenericDeleteDialog: false,
      genericDialogContent: "",
      bookingId: "",
      seatBookingId: "",
      id: ""
    };
  },
  methods: {
    ...toastNotificationMethods,
    ...toastNotificationMutations,
    closeGenericDeleteDialog() {
      this.showGenericDeleteDialog = false;
    },
    showDeleteDialog(bookingId, seatBookingId) {
      this.bookingId = bookingId;
      this.seatBookingId = seatBookingId;
      this.showGenericDeleteDialog = true;
    },
    async getAll() {
      var response = await BookingService.getAll(this.id);
      if (typeof response !== "undefined" && response.success && typeof response.data !== "undefined") {
        this.selectedEvent = response.data.selectedEvent;
        this.items = response.data.bookings;
      }
    },
    async removeSeatBooking() {
      var response = await BookingService.removeSeatBooking(this.id, this.bookingId, this.seatBookingId);
      if (typeof response !== "undefined" && response.success && typeof response.data !== "undefined") {
        this.items = response.data;

        this.SHOW_TOAST_NOTIFICATION({ message: "Delete successful...", statusCode: this.notificationStatusCode.success });
      } else {
        this.SHOW_TOAST_NOTIFICATION({ message: "Delete failed...", statusCode: this.notificationStatusCode.error });
      }
      this.showGenericDeleteDialog = false;
    },
    async exportData() {
      var response = await BookingService.exportBookingsByEventId(this.id);
      if (typeof response !== "undefined") {
        var filename = response.filename;

        // console.log("response ", response);
        // console.log("response 2 ", [response]);

        // if (typeof response.headers !== "undefined") {
        //   var contentDisposition = response.headers["content-disposition"];
        //   if (typeof contentDisposition !== "undefined") {
        //     var match = contentDisposition.match(/filename\s*=\s*"(.+)"/i);
        //     filename = match[1];
        //   }
        // }

        let blob = new Blob([response.data], { type: "text/csv" });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename || "download-" + Date.now();
        link.click();
      }
    }
  },
  created() {
    this.id = this.$route.params.id;
    this.getAll();
  }
};
</script>

<style scoped>
</style>